import { ConfigEditor } from "./ConfigEditor.js";
import { ExecutionView } from "./ExecutionView.js";
import { Icon } from "./Icon.js";
import { configSchema, dataSchema, defaultConfig } from "./schema.js";
/**
 * Sub-Module action type plugin.
 * Allows a module to reference another module as an action, creating nested
 * workflows. The sub-module action auto-completes when all required actions
 * in the nested module are completed.
 * @example
 * ```typescript
 * // Configuration set by admin:
 * {
 *   targetModuleId: "uuid-of-nested-module",
 *   displayMode: "expanded"
 * }
 *
 * // Data produced on completion:
 * {
 *   completedActions: 5,
 *   totalRequiredActions: 5,
 *   isComplete: true
 * }
 * ```
 */
export const submodulePlugin = {
    // Identity
    slug: "submodule",
    name: "Sub-Module",
    description: "Embed another module as a nested workflow within this module",
    // Classification
    type: "comment", // Use "comment" base type for UI grouping (informational/workflow)
    completionType: "submodule_complete",
    // Schemas
    configSchema,
    dataSchema,
    // Handlers
    handlers: {
        onStart: (ctx) => {
            ctx.logger.info("Sub-module action started", {
                actionId: ctx.execution.moduleActionId,
                targetModuleId: ctx.config.targetModuleId,
                userId: ctx.userId,
            });
            return Promise.resolve();
        },
        onComplete: (ctx, data) => {
            ctx.logger.info("Sub-module action completed", {
                actionId: ctx.execution.moduleActionId,
                targetModuleId: ctx.config.targetModuleId,
                userId: ctx.userId,
                completedActions: data.completedActions,
                totalRequiredActions: data.totalRequiredActions,
            });
            // Verify nested module is actually complete
            if (!data.isComplete) {
                throw new Error(`Cannot complete sub-module: ${data.totalRequiredActions - data.completedActions} required actions remaining`);
            }
            return Promise.resolve();
        },
    },
    // Components
    components: {
        Icon,
        ConfigEditor,
        ExecutionView,
    },
    // Defaults
    defaultConfig,
    order: 5, // After basic types
    // Metadata
    version: "1.0.0",
    author: "Nucleus Team",
};
export { SubmoduleContext } from "./ExecutionView.js";
export { MAX_NESTING_DEPTH, displayModes } from "./schema.js";
//# sourceMappingURL=index.js.map